import { render, staticRenderFns } from "./ZoneEditBasic.vue?vue&type=template&id=12182449&scoped=true&"
import script from "./ZoneEditBasic.vue?vue&type=script&lang=js&"
export * from "./ZoneEditBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12182449",
  null
  
)

export default component.exports